// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_9Ez","cls2":"ImpactHubModal-cls2_NYi ImpactHubModal-cls1_9Ez"};